import { TableHead, SearchData } from "../../../../common/dataClass/Default"

class WarehouseAllocationTableHead extends TableHead{
  constructor(name, prop, width, obj) {
    super(name, prop, width, obj)
  }
}

/**出仓单入仓单搜索数据 */
class OrderSearchData extends SearchData{
  constructor() {
    super()
    /**日期 */
    this.date = ''
    /**货件分类 */
    this.goodsSort = ''
    /**发往国家 */
    this.countrySite = ''
    /**分类 */
    this.orderSort = ''
  }
}

/**出仓登记搜索数据 */
class OutLogSearchData extends SearchData{
  constructor() {
    super()
    /**出仓日期 */
    this.date = ''
    /**货件分类 */
    this.goodsSort = ''
    /**仓库分类 */
    this.warehouseSort = ''
    /**发往国家 */
    this.countrySite = ''
    /**出仓单分类 */
    this.orderSort = ''
  }
}

/**入仓登记搜索数据 */
class InLogSearchData extends SearchData{
  constructor() {
    super()
    /**入仓日期 */
    this.date = ''
    /**仓库分类 */
    this.warehouseSort = ''
    /**入仓单分类 */
    this.orderSort = ''
  }
}

class WarehouseAllocationNewModule{
  /**入仓单表头 */
  static NEWINORDERTABLEHEAD(){
    let arr = [
      new WarehouseAllocationTableHead('入仓单编号', 'img', '200'),
      new WarehouseAllocationTableHead('入仓分类', 'getCostOfCommodityInvestmentByTable', '200'),
      new WarehouseAllocationTableHead('货件分类', 'getNetProfitOfGoodsByTable', '200'),
      new WarehouseAllocationTableHead('FBA发补货计划单数量', 'stockPrice', '100'),
      new WarehouseAllocationTableHead('采购单编号', 'getSavePriceByTable', '100'),
      new WarehouseAllocationTableHead('货件追踪单号<br>(Amazon ref.ID)', 'disposalNum', '120'),
      new WarehouseAllocationTableHead('FBA编号<br>(FBA ID)', 'getCostSummaryByTable', '100'),
      new WarehouseAllocationTableHead('发往国家', 'getCostSummaryByTable', '100'),
      new WarehouseAllocationTableHead('发货编号', 'disposalNum', '100'),
      new WarehouseAllocationTableHead('Asin数量', 'disposalNum', '100'),
      new WarehouseAllocationTableHead('总箱数', 'getShowNumAndActualNumByTable', '100'),
      new WarehouseAllocationTableHead('总重量<br>(kg)', 'getShowNumAndActualNumByTable', '80'),
      new WarehouseAllocationTableHead('总体积<br>(M³)', 'stockPrice', '80'),
      new WarehouseAllocationTableHead('入仓日期', 'stockPrice', '100'),
      new WarehouseAllocationTableHead('操作', 'disposalNum', '150'),
    ]
    return arr
  }
  /**出仓单表头 */
  static NEWOUTORDERTABLEHEAD(){
    let arr = [
      new WarehouseAllocationTableHead('出仓单编号', 'img', '100'),
      new WarehouseAllocationTableHead('出仓分类', 'getCostOfCommodityInvestmentByTable', '100'),
      new WarehouseAllocationTableHead('发货单号', 'getNetProfitOfGoodsByTable', '100'),
      new WarehouseAllocationTableHead('调出仓库名称-仓库代码<br>(仓库分类)', 'getCostSummaryByTable', '200'),
      new WarehouseAllocationTableHead('FBA发补货计划单数量', 'stockPrice', '150'),
      new WarehouseAllocationTableHead('FBA发补货计划单号', 'getSavePriceByTable', '120'),
      new WarehouseAllocationTableHead('货件追踪单号<br>(Amazon ref.ID)', 'disposalNum', '100'),
      new WarehouseAllocationTableHead('FBA编号<br>(FBA ID)', 'getCostSummaryByTable', '100'),
      new WarehouseAllocationTableHead('所属店铺', 'getCostSummaryByTable', '80'),
      new WarehouseAllocationTableHead('发往国家', 'getCostSummaryByTable', '80'),
      new WarehouseAllocationTableHead('Asin数量', 'disposalNum', '80'),
      new WarehouseAllocationTableHead('出仓总数量', 'disposalNum', '80'),
      new WarehouseAllocationTableHead('总箱数', 'getShowNumAndActualNumByTable', '80'),
      new WarehouseAllocationTableHead('总重量<br>(kg)', 'getShowNumAndActualNumByTable', '80'),
      new WarehouseAllocationTableHead('总体积<br>(M³)', 'stockPrice', '80'),
      new WarehouseAllocationTableHead('出仓日期', 'stockPrice', '100'),
      new WarehouseAllocationTableHead('操作', 'disposalNum', '80'),
    ]
    return arr
  }
  /**发货任务表头 */
  static NEWTASKTABLEHEAD(){
    let arr = [
      new WarehouseAllocationTableHead('发货单号', 'img', '100'),
      new WarehouseAllocationTableHead('出仓分类', 'getCostOfCommodityInvestmentByTable', '100'),
      new WarehouseAllocationTableHead('包含FBA发补货<br>计划单数量', 'getNetProfitOfGoodsByTable', '200'),
      new WarehouseAllocationTableHead('货物当前所在<br>仓库的数量', 'getCostSummaryByTable', '200'),
      new WarehouseAllocationTableHead('Asin数量', 'disposalNum', '80'),
      new WarehouseAllocationTableHead('总箱数', 'getShowNumAndActualNumByTable', '80'),
      new WarehouseAllocationTableHead('总重量<br>(kg)', 'getShowNumAndActualNumByTable', '80'),
      new WarehouseAllocationTableHead('总体积<br>(M³)', 'stockPrice', '80'),
      new WarehouseAllocationTableHead('发往城市', 'getSavePriceByTable', '120'),
      new WarehouseAllocationTableHead('物流公司', 'disposalNum', '100'),
      new WarehouseAllocationTableHead('寄件方式', 'getCostSummaryByTable', '100'),
      new WarehouseAllocationTableHead('创建日期', 'getCostSummaryByTable', '80'),
      new WarehouseAllocationTableHead('出货日期', 'getCostSummaryByTable', '80'),
      new WarehouseAllocationTableHead('物流单号', 'stockPrice', '150'),
      new WarehouseAllocationTableHead('发货状态', 'disposalNum', '80'),
      new WarehouseAllocationTableHead('操作', 'disposalNum', '80'),
    ]
    return arr
  }
  /**出仓登记表头 */
  static NEWOUTLOGTABLEHEAD(){
    let arr = [
      new WarehouseAllocationTableHead('出仓分类', 'getCostOfCommodityInvestmentByTable', '100'),
      new WarehouseAllocationTableHead('FBA发补货计划单号', 'getSavePriceByTable', '120'),
      new WarehouseAllocationTableHead('货件追踪单号<br>(Amazon ref.ID)', 'disposalNum', '100'),
      new WarehouseAllocationTableHead('FBA编号<br>(FBA ID)', 'getCostSummaryByTable', '100'),
      new WarehouseAllocationTableHead('国家站点', 'getCostSummaryByTable', '80'),
      new WarehouseAllocationTableHead('总箱数', 'getShowNumAndActualNumByTable', '80'),
      new WarehouseAllocationTableHead('总重量<br>(kg)', 'getShowNumAndActualNumByTable', '80'),
      new WarehouseAllocationTableHead('总体积<br>(M³)', 'stockPrice', '80'),
      new WarehouseAllocationTableHead('调出仓库名称-仓库代码<br>(仓库分类)', 'getCostSummaryByTable', '200'),
      new WarehouseAllocationTableHead('货物所在仓库数量', 'stockPrice', '150'),
      new WarehouseAllocationTableHead('Asin数量', 'disposalNum', '80'),
      new WarehouseAllocationTableHead('已入仓/需出仓<br>商品数量', 'getCostSummaryByTable', '80'),
      new WarehouseAllocationTableHead('计划出仓日期<br>实际出仓日期', 'stockPrice', '100'),
      new WarehouseAllocationTableHead('发货单号', 'getNetProfitOfGoodsByTable', '100'),
      new WarehouseAllocationTableHead('备货完成状况', 'getNetProfitOfGoodsByTable', '100'),
      new WarehouseAllocationTableHead('操作', 'disposalNum', '80'),
    ]
    return arr
  }
  /**入仓登记表头 */
  static NEWINLOGTABLEHEAD(){
    let arr = [
      new WarehouseAllocationTableHead('入仓分类', 'getCostOfCommodityInvestmentByTable', '200'),
      new WarehouseAllocationTableHead('采购单号<br>或产品储备单号', 'img', '200'),
      new WarehouseAllocationTableHead('对应FBA发补货<br>计划单数量', 'getNetProfitOfGoodsByTable', '200'),
      new WarehouseAllocationTableHead('供应商', 'stockPrice', '100'),
      new WarehouseAllocationTableHead('总箱数', 'getShowNumAndActualNumByTable', '100'),
      new WarehouseAllocationTableHead('总重量<br>(kg)', 'getShowNumAndActualNumByTable', '80'),
      new WarehouseAllocationTableHead('总体积<br>(M³)', 'stockPrice', '80'),
      new WarehouseAllocationTableHead('仓库名称<br>(自编仓库代码)', 'getSavePriceByTable', '100'),
      new WarehouseAllocationTableHead('仓库所属<br>(仓库分类)', 'disposalNum', '120'),
      new WarehouseAllocationTableHead('入仓日期', 'getCostSummaryByTable', '100'),
      new WarehouseAllocationTableHead('需入仓数量', 'getCostSummaryByTable', '100'),
      new WarehouseAllocationTableHead('已入仓数量', 'disposalNum', '100'),
      new WarehouseAllocationTableHead('待入仓数量', 'disposalNum', '100'),
      new WarehouseAllocationTableHead('入仓完成状况', 'disposalNum', '100'),
      new WarehouseAllocationTableHead('入仓详细', 'stockPrice', '100'),
      new WarehouseAllocationTableHead('操作', 'disposalNum', '150'),
    ]
    return arr
  }
}

export {
  WarehouseAllocationNewModule, OrderSearchData, OutLogSearchData, InLogSearchData
}
